import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportRoutingModule } from './report-routing.module';
import { WithdrawRialComponent } from './components/withdraw-rial/withdraw-rial.component';
import { WithdrawCryptoComponent } from './components/withdraw-crypto/withdraw-crypto.component';
import { DepositRialComponent } from './components/deposit-rial/deposit-rial.component';
import { DepositCryptoComponent } from './components/deposit-crypto/deposit-crypto.component';
import { SharedModule } from 'src/app/shared/shared.module';
import {
  NbAccordionModule,
  NbToggleModule,
  NbSpinnerModule,
  NbTooltipModule,
  NbPopoverModule,
  NbBadgeModule,
  NbTagModule, NbAutocompleteModule, NbRadioModule, NbButtonGroupModule, NbListModule, NbUserModule, NbProgressBarModule
} from '@nebular/theme';
import { TableModule } from 'primeng/table';
import { GiftCardComponent } from './components/gift-card/gift-card.component';
import { WithdrawTreasuryComponent } from './components/withdraw-treasury/withdraw-treasury.component';
import { DepositTreasuryComponent } from './components/deposit-treasury/deposit-treasury.component';
import { WithdrawModule } from '../withdraw/withdraw.module';
import { GeneralReportsComponent } from './components/general-reports/general-reports.component';
import { ReportOutputTypePipe } from './pipes/report-output-type.pipe';
import { ReportPageComponent } from './components/general-reports/report-page/report-page.component';
import { GeneralReportUserFilterComponent } from './components/general-reports/custom-user-picker/general-report-user-filter.component';
import { FormsModule } from '@angular/forms';
import { ReportOutputPipe } from './pipes/report-output.pipe';
import { SearchReportPipe } from './pipes/search-report.pipe';
import { UserSearchQueryPlaceholderPipe } from './pipes/user-search-query-placeholder.pipe';
import { ReportAccessListComponent } from './components/general-reports/report-access-list/report-access-list.component';
import { SearchScopePipe } from './pipes/search-scope.pipe';
import { SearchAdminUserPipe } from './pipes/search-admin-user.pipe';
import { DatetimeRangePickerComponent } from './components/general-reports/datetime-range-picker/datetime-range-picker.component';
import { ReportQueueComponent } from './components/general-reports/report-queue/report-queue.component';
import { DownloadWithCredentialDirective } from './directives/download-with-credential.directive';

@NgModule({
  declarations: [
    WithdrawRialComponent,
    WithdrawCryptoComponent,
    DepositRialComponent,
    DepositCryptoComponent,
    GiftCardComponent,
    WithdrawTreasuryComponent,
    DepositTreasuryComponent,
    GeneralReportsComponent,
    ReportOutputTypePipe,
    ReportPageComponent,
    GeneralReportUserFilterComponent,
    ReportOutputPipe,
    SearchReportPipe,
    UserSearchQueryPlaceholderPipe,
    ReportAccessListComponent,
    SearchScopePipe,
    SearchAdminUserPipe,
    DatetimeRangePickerComponent,
    ReportQueueComponent,
    DownloadWithCredentialDirective
  ],
  exports: [
    GeneralReportUserFilterComponent
  ],
  imports: [
    CommonModule,
    ReportRoutingModule,
    SharedModule,
    NbAccordionModule,
    TableModule,
    NbTooltipModule,
    WithdrawModule,
    NbToggleModule,
    NbSpinnerModule,
    NbPopoverModule,
    NbBadgeModule,
    NbTagModule,
    FormsModule,
    NbAutocompleteModule,
    NbRadioModule,
    NbButtonGroupModule,
    NbListModule,
    NbUserModule,
    NbProgressBarModule
  ]
})
export class ReportModule {
}
